/**
 * C.14 — Reverse-open bridge from external windows (Skill Library, etc.)
 * back into the Obsidian Vault window. The caller dispatches
 * `requestVaultSelect(path)` and the Obsidian Vault window subscribes
 * via `subscribeVaultSelect(handler)`; once notified, it opens the
 * window, focuses it, and selects the requested path into pane A.
 *
 * Tiny pub/sub instead of React context — the caller and the vault
 * window don't share a component tree.
 */

type Handler = (path: string) => void;

const handlers = new Set<Handler>();

export function requestVaultSelect(path: string): void {
  for (const h of handlers) h(path);
}

export function subscribeVaultSelect(h: Handler): () => void {
  handlers.add(h);
  return () => handlers.delete(h);
}
